module.exports = __webpack_public_path__ + "img/Logo(2).b6da16bb.png";